module.exports = __webpack_public_path__ + "img/10.cfd26fe1.jpg";